var map = {
	"./01_Isabelle Ihl Architektur_Wohnungsbau_Modellfoto Innenraum.jpg": 4582,
	"./02_Isabelle Ihl Architektur_Wohnungsbau_Grundriss Erdgeschoss.jpg": 8548,
	"./03_Isabelle Ihl Architektur_Wohnungsbau_Grundriss 1.Obergeschoss.jpg": 3758,
	"./04_Isabelle Ihl Architektur_Wohnungsbau_Grundriss 2.Obergeschoss.jpg": 3607,
	"./05_Isabelle-Ihl-Architektur_Wohnungsbau_Schnitt.jpg": 9922,
	"assets/c2_epfl/01_Isabelle Ihl Architektur_Wohnungsbau_Modellfoto Innenraum.jpg": 4582,
	"assets/c2_epfl/02_Isabelle Ihl Architektur_Wohnungsbau_Grundriss Erdgeschoss.jpg": 8548,
	"assets/c2_epfl/03_Isabelle Ihl Architektur_Wohnungsbau_Grundriss 1.Obergeschoss.jpg": 3758,
	"assets/c2_epfl/04_Isabelle Ihl Architektur_Wohnungsbau_Grundriss 2.Obergeschoss.jpg": 3607,
	"assets/c2_epfl/05_Isabelle-Ihl-Architektur_Wohnungsbau_Schnitt.jpg": 9922
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1869;